import React, { useState } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import trash from "./../../../Assets/Images/trash.png";
import ReactLoading from "react-loading";
import toast from "react-hot-toast";

//Components
import {
  toastStyle,
} from "../../../Helpers/Utils/Common";
import {
  createCategories,
  updateCategories,
  getAllCategories,
} from "../../../Helpers/apiCalls/Manage/Categories";

function FormCategory({ add, edit }) {
  //*****VARIABLES*****
  const { id } = useParams();
  let navigate = useNavigate();
  const [inactive, setInactive] = useState(true);
  const [isClicked, setIsClicked] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [addInventoryData, setAddInventoryData] = useState({});

  //*****FUNCTIONS*****
  function renderTable() {
    return (
      <Table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {/* {} */}
          {selectedProducts.map((product, index) => {
            return (
              <tr>
                <td>
                  <Form.Control
                    type="text"
                    name="subcategory_name"
                    value={product.subcategory_name}
                    className="nc-modal-custom-input-edit"
                    onChange={(e) => handleAddNameChange(e, index)}
                    required
                  />
                </td>
                <td>
                  <div className="align-middle">
                    <img
                      src={trash}
                      alt="delete"
                      onClick={() => handleRemoveBranch(index)}
                      className="cursor-pointer"
                    />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }

  const handleAddNameChange = (e, index) => {
    const { name, value } = e.target;
    var newData = [...selectedProducts];
    newData[index][name] = value;
    setSelectedProducts(newData);
  };
  
  function handleRemoveBranch(id) {
    const rowId = id;
    const newItemList = [...selectedProducts];
    newItemList.splice(rowId, 1);
    setSelectedProducts(newItemList);
  }

  function handleAddBranch() {
    const newItem = {
      id: "",
      name: "",
    };
    setSelectedProducts((prevItems) => [...prevItems, newItem]);
  }

  const handleAddChange = (e) => {
    const { name, value } = e.target;
    setAddInventoryData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    if (add) {
      createInventory();
    } else if (edit) {
      updateInventory();
    }
  };

  async function createInventory() {
    setIsClicked(true);
      const response = await createCategories(addInventoryData, selectedProducts);
      if (response.data) {
        toast.success(response.data.message, {
            style: toastStyle(),
        });
        navigate(-1)
      } else {
        response.error?.response?.data?.messages.map((data) => {
            return toast.error(data);
        })
      }
    setIsClicked(false);
  }

  async function updateInventory() {
    setIsClicked(true);
    const response = await updateCategories(addInventoryData, selectedProducts);
      if (response.data) {
        toast.success(response.data.message, {
            style: toastStyle(),
        });
        navigate(-1)
      } else {
        response.error?.response?.data?.messages.map((data) => {
            return toast.error(data);
        })
      }
      setIsClicked(false);
  }

  async function fetchCategory() {
    const response = await getAllCategories({category_id: id});
    if (response.data) {
        setAddInventoryData(response.data.data[0]);
        const res = response.data.data[0].subcategories.map((row) => {
            var info = row
            info.subcategory_name = row.subname
            return info;
        })
        setSelectedProducts(res);
    }
  }

  //****** Useeffect *****/
  React.useEffect(() => {
    if (edit) {
      fetchCategory();
    }
  }, []);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"SUPPLIES"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <div className="row">
          <h1 className="page-title mb-4"> Category</h1>
        </div>

        <div className="edit-form">
          <Row className="nc-modal-custom-row mt-0">
            <Col>
              NAME
              <span className="required-icon">*</span>
              <Form.Control
                type="text"
                name="name"
                defaultValue={addInventoryData?.name}
                className="nc-modal-custom-input-edit"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>

          <Row className="nc-modal-custom-row">
            <Col>SUBCATEGORY</Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <div className="edit-purchased-items">
              {selectedProducts.length === 0 ? (
                <span>No Subcategory Found!</span>
              ) : (
                renderTable()
              )}
            </div>
          </Row>
          <Row className="pt-3 PO-add-item">
            <Button type="button" onClick={() => handleAddBranch()}>
              Add Subcategory
            </Button>
          </Row>

          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary me-3"
              onClick={() => navigate("/category")}
            >
              Cancel
            </button>
            {isClicked ? (
              <div className="button-primary me-3 d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <button
                type="button"
                className="button-primary me-3"
                onClick={handleSubmit}
              >
                Save
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FormCategory;
